/**
 * Types specific to the main app
 */

export enum VideoDisplayMode {
  NO_RECORDING = "no-recording",
  PROCESSING = "processing",
  IN_PROGRESS = "in-progress",
  VIDEO = "video",
  AUDIO = "audio",
}

export type ClipPlayRange = {
  play: number;
} & ClipRange;

export type ClipRange = {
  start: number;
  end: number;
};
